import { Navigate, createFileRoute, useNavigate } from '@tanstack/react-router'

import { CareLogEditPage } from './-care-log-edit-page'
import { validateCareLogNewSearch } from './-care-log-new-search'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/care-logs/new',
)({
    // `?activity=<code>` chọn sẵn hoạt động (deep link nhắc việc);
    // `?area_id=<uuid>` mở từ mã QR vùng trồng (điền sẵn bước Địa điểm).
    validateSearch: validateCareLogNewSearch,
    component: CareLogCreatePage,
})

function CareLogCreatePage() {
    const navigate = useNavigate()
    const { hasPermission } = useAuth()
    const { activity, area_id } = Route.useSearch()

    // Không có quyền ghi thì không cho vào trang tạo (kể cả mở thẳng URL).
    if (!hasPermission('care_logs.write')) {
        return <Navigate to="/agriculture/care-logs" />
    }

    const back = () => navigate({ to: '/agriculture/care-logs' })
    return (
        <CareLogEditPage
            mode="create"
            initialActivity={activity}
            initialAreaId={area_id}
            onSaved={back}
            onBack={back}
        />
    )
}
